import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  authSelector,
  dataPortalLookupListSelector,
} from "../../redux/selectors";
import { LookupList } from "./LookupList";
import { Box, makeStyles, Typography } from "@material-ui/core";
import { OrgSelect } from "./OrgSelect";
import { UserType } from "@ofqual/portal-client-shell/dist/module/redux/state";
import { loadingDataPortalLookups } from "../../redux/actions";
import { Skeleton } from "@material-ui/lab";
import { ModuleAppBar } from "../ModuleAppBar";

const useStyles = makeStyles((theme) => {
  return {
    root: {
      marginTop: theme.contentOffsets.AFTER_SECONDARY_APPBAR,
    },
  };
});

export const Lookups: React.FC = () => {
  const items = useSelector(dataPortalLookupListSelector);
  const dispatch = useDispatch();
  const { userType } = useSelector(authSelector);
  const {
    org: { id },
  } = useSelector(authSelector);

  const { org } = useSelector(authSelector);

  const classes = useStyles();
  const isOfqual: boolean = userType === UserType.Ofqual;
  const orgId: any = id;

  useEffect(() => {
    if (!isOfqual) {
      dispatch(loadingDataPortalLookups(orgId));
    }
  }, [dispatch, isOfqual, orgId]);

  return (
    <div className={classes.root}>
      <ModuleAppBar breadcrumbs={[]} />
      <Typography variant="h6">My Submissions</Typography>
      {isOfqual && <OrgSelect />}
      <br />
      <br />
      {items.status === "LOADING" ? (
        <>
          <Skeleton variant="text" height={60} />
          <Skeleton variant="text" height={60} />
          <Skeleton variant="text" height={60} />
          <br />
          <Skeleton variant="rect" height={118} />
        </>
      ) : items.hasData ? (
        <Box sx={{ minHeight: 800, bgcolor: "background.paper" }}>
          <LookupList state={items} />
        </Box>
      ) : null}
    </div>
  );
};
